import { Component, Input } from "@angular/core";

@Component({
    selector: 'zx-icon-compatible',
    template: '<i nz-icon [nzType]="type" [nzTheme]="theme" [ngClass]="unknowIconClass"></i>'
})
export class IconCompatibleComponent{

    _iconClass:string;
    _iconType:string;

    @Input("zxIconClass") 
    set iconClass(v:string){
        if(!v) {
            this._iconClass = null;
            this._iconType = null;
        }else{
            this._iconClass = v;
            this._iconType = v
                    .replace('anticon-', '')
                    .replace('anticon', '')
                    .replace(/\-o$/, '').trim();
        }
    }
    get iconClass(): string{
        return this._iconClass;
    }

    constructor(){}

    get type(): string {
        return this._iconType;
    }

    get theme(): string {
        if (!this.iconClass) { return null; }
        return 'outline';
        // return this.iconClass.match(/\-o$/) ? 'outline' : 'fill';
    }

    get unknowIconClass(): string{
        return this._iconType?null:this._iconClass;
    }
}